// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reports-container[data-v-07ccc816]{background-color:var(--v-background-base,#f5f5f5)}.theme--dark .reports-container[data-v-07ccc816]{background-color:#121212!important}.small-chat-img[data-v-07ccc816]{display:none!important}", ""]);
// Exports
module.exports = exports;
